import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {
    StyledAgendaSidebarCard,
    StyledAgendaSidebarCardTitle
} from '@/features/agenda/components/agenda-sidebar-card/style'
import {ReactNode} from 'react'

interface AgendaSidebarCardProps {
    children: ReactNode
    title?: string
    subtitle?: string
    onRemove?: () => void
    onClickTitle?: () => void
    isSelected?: boolean
}

export const AgendaSidebarCard = ({
    title,
    subtitle,
    children,
    onRemove,
    onClickTitle,
    isSelected
}: AgendaSidebarCardProps) => {
    return (
        <StyledAgendaSidebarCard direction="column" gap={2.5} fullWidth $isSelected={!!isSelected}>
            {title && (
                <Flexbox justify="space-between" align="flex-start" fullWidth>
                    <Flexbox direction="column" gap={1}>
                        <StyledAgendaSidebarCardTitle role="button" onClick={onClickTitle} $isPointer={!!onClickTitle}>
                            {title}
                        </StyledAgendaSidebarCardTitle>
                        {subtitle && (
                            <Text size="textXs" palette="neutral" shade="500">
                                {subtitle}
                            </Text>
                        )}
                    </Flexbox>
                    {onRemove && (
                        <Button onClick={onRemove} variant="ghost" shape="text" style={{marginTop: 4}}>
                            <XCloseIcon />
                        </Button>
                    )}
                </Flexbox>
            )}
            {children}
        </StyledAgendaSidebarCard>
    )
}
